import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store/store';
import { setAnlyticsFilter } from '../../utils/facadeReducer';
import { Icon } from '../Icon';
import { useTranslation } from 'react-i18next';
import { AnalyticsVesselTypeEnum, AnalyticsPeriodEnum } from 'ais-facade-api/api';
import { Button } from 'app/components/Button';
import { RadioGroup } from 'app/components/RadioGroup';

import styles from './AnalyticsFilterPanel.module.scss';

export const AnalyticsFilterPanel: React.FC = () => {

  const AnalyticsVesselTypeEnum = {
    CountAll: 'COUNT_ALL' as AnalyticsVesselTypeEnum,
    Fish: 'FISH' as AnalyticsVesselTypeEnum,
    Special: 'SPECIAL' as AnalyticsVesselTypeEnum,
    Walking: 'WALKING' as AnalyticsVesselTypeEnum,
    Speed: 'SPEED' as AnalyticsVesselTypeEnum,
    Passenger: 'PASSENGER' as AnalyticsVesselTypeEnum,
    Tanker: 'TANKER' as AnalyticsVesselTypeEnum,
    Cargo: 'CARGO' as AnalyticsVesselTypeEnum,
    Other: 'OTHER' as AnalyticsVesselTypeEnum
  }

  const AnalyticsPeriodEnum = {
    Day: 'DAY' as AnalyticsPeriodEnum,
    Week: 'WEEK' as AnalyticsPeriodEnum,
    Month: 'MONTH' as AnalyticsPeriodEnum
  }

  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const mode = useAppSelector((state) => state.mapStateSlice.mode);
  const isAnalyticsMode = mode === 'analytics';
  const { mode: analyticsMode } = window._env_?.ANALYTICS_CONFIG ? JSON.parse(window._env_.ANALYTICS_CONFIG) : '';

  const [period, setPeriod] = useState<AnalyticsPeriodEnum>(AnalyticsPeriodEnum.Week);
  const [shipType, setShipType] = useState<AnalyticsVesselTypeEnum>(AnalyticsVesselTypeEnum.CountAll);


  /*
     сброс стейта фильтров в значения по умолчанию, при переходе на другие страницы
  */
  useEffect(() => {
    if (!isAnalyticsMode) {
      dispatch(setAnlyticsFilter({ period: AnalyticsPeriodEnum.Week, shipType: AnalyticsVesselTypeEnum.CountAll }));
    }
  }, [isAnalyticsMode]);

  const handlePeriodChange = (event: React.ChangeEvent<HTMLInputElement>) => setPeriod(event.target.value as AnalyticsPeriodEnum);
  const handleShipTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => setShipType(event.target.value as AnalyticsVesselTypeEnum);
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    dispatch(setAnlyticsFilter({ period, shipType }));
  };

  const periodOptions = [
    { value: AnalyticsPeriodEnum.Day, label: t('Day') },
    { value: AnalyticsPeriodEnum.Week, label: t('Week') },
    { value: AnalyticsPeriodEnum.Month, label: t('Month') },
  ]

  const shipTypeOptions = [
    { value: AnalyticsVesselTypeEnum.CountAll, label: t('CheckboxLabelAllType') },
    { value: AnalyticsVesselTypeEnum.Cargo, label: t('VesselTypeCargo') },
    { value: AnalyticsVesselTypeEnum.Passenger, label: t('VesselTypePassenger') },
    { value: AnalyticsVesselTypeEnum.Speed, label: t('VesselTypeSpeed') },
    { value: AnalyticsVesselTypeEnum.Walking, label: t('VesselTypePleasure') },
    { value: AnalyticsVesselTypeEnum.Tanker, label: t('VesselTypeTanker') },
    { value: AnalyticsVesselTypeEnum.Fish, label: t('VesselTypeFishing') },
    { value: AnalyticsVesselTypeEnum.Special, label: t('VesselTypeSpecialTug') },
    { value: AnalyticsVesselTypeEnum.Other, label: t('VesselTypeOther') },
  ];

  return (
    <div className={styles.filter_panel}>
      <div className={styles.heading}>
        <Icon name="analytics" className={styles.heading_icon} />
        <span>{t('Analytics')}</span>
      </div>
      <form onSubmit={handleSubmit} className={styles.filter_panel_form}>
        <div className={styles.filter_panel_container}>
          <RadioGroup label={t('Period')} name="period" options={periodOptions} selectedValue={period} onChange={handlePeriodChange} />
          <RadioGroup label={t('ShipTypesLabel')} name="shipType" options={shipTypeOptions} selectedValue={shipType} onChange={handleShipTypeChange} />
          <Button className={styles.action_button} label={t('Apply')} variant="general" type="submit" />
        </div>
        <div className={styles.gradient_legend_container}>
          <div className={analyticsMode === 'dynamic' ? styles.gradient_legend : styles.gradient_legend_static}></div>
          <div className={styles.legend_labels}>
            <span>{t('Less')}</span>
            <span>{t('More')}</span>
          </div>
        </div>
      </form>
    </div>
  );
};
